import { post } from '../../../utils/request'

export async function acc () {
    return await post('/api/usr/pro/get')
  }